import * as yup from "yup";

export const profileValidation = yup.object().shape({
  name: yup.string().required("Full name is required"),
  mobile: yup.string().required("Mobile number is required"),
});
